import type { Folder, MessageListItem, MessageFull } from "./types";
import { getHostContext } from "./hostContext";

export const mockFolders: Folder[] = [
  { id: "INBOX", name: "Inbox", unread: 2 },
  { id: "Sent", name: "Sent", unread: 0 },
  { id: "Drafts", name: "Drafts", unread: 0 },
  { id: "Archive", name: "Archive", unread: 0 },
  { id: "Spam", name: "Spam", unread: 0 },
  { id: "Trash", name: "Trash", unread: 0 }
];

function fromAddr(localpart: string): string {
  const d = getHostContext().mockEmailDomain;
  return `${localpart}@${d}`;
}

export function mockMessages(folderId: string): MessageListItem[] {
  const now = Date.now();
  const base = (n: number) => new Date(now - n * 3600_000).toISOString();
  const prefix = folderId === "INBOX" ? "Inbox" : folderId;
  const brand = getHostContext().brandName;

  return [
    {
      id: `${folderId}:1`,
      from: fromAddr("support"),
      subject: `${prefix}: Welcome`,
      dateIso: base(2),
      snippet: `Welcome to ${brand} Webmail MVP.`,
      unread: folderId === "INBOX"
    },
    {
      id: `${folderId}:2`,
      from: fromAddr("alerts"),
      subject: `${prefix}: Security notice`,
      dateIso: base(5),
      snippet: "A sign-in was detected from a new device.",
      unread: folderId === "INBOX"
    },
    {
      id: `${folderId}:3`,
      from: fromAddr("noreply"),
      subject: `${prefix}: Weekly summary`,
      dateIso: base(30),
      snippet: "Your weekly account summary is ready.",
      unread: false
    }
  ];
}

export function mockMessageFull(id: string): MessageFull {
  const brand = getHostContext().brandName;
  const you = `you@${getHostContext().mockEmailDomain}`;

  return {
    id,
    from: fromAddr("support"),
    to: you,
    subject: "Welcome",
    dateIso: new Date().toISOString(),
    text:
`This is placeholder content.

Next:
- Hook folders/messages to /api/mail endpoints
- Add compose + send flow
- Add rate limits + lockouts

(Generated UI skeleton for ${brand})`
  };
}
